import { Theme } from '@material-ui/core/styles';

export const getMuiCheckbox = (theme: Theme): Record<string, unknown> => ({
  MuiCheckbox: {
    root: {
      marginRight: '.625rem',
      padding: 0,

      '&.Mui-checked': {
        '& [class*="MuiSvgIcon-root"]': {
          '& > *': {
            stroke: theme.palette.common.white,
          },
        },
      },

      '&.Mui-disabled': {
        '& [class*="MuiSvgIcon-root"]': {
          '& > *': {
            stroke: theme.palette.grey[500],
          },
        },
      },

      '&.Mui-checked.Mui-disabled': {
        '& [class*="MuiSvgIcon-root"]': {
          '& > *:first-child': {
            fill: theme.palette.grey[500],
          },
        },
      },

      '& [class*="MuiSvgIcon-root"]': {
        '& > *': {
          stroke: theme.palette.grey[800],
        },
      },
      '& :hover': {
        backgroundColor: theme.palette.common.white,
      },
    },
  },
});
